import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { IoPause, IoPlay } from "react-icons/io5";
import "../../Css/homeCategory/HomeCategory.css";
import productreelsPerfume from "../../Images/Video/1FIVE Fragrance.mp4";

const HomePerfumeProduct = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);

    const handlePlay = async () => {
        try {
            await videoRef.current?.play();
            setIsPlaying(true);
        } catch (error) {
            console.error("Unable to play video:", error);
        }
    };

    const handlePause = () => {
        videoRef.current?.pause();
        setIsPlaying(false);
    };

    return (
        <div className="home-category-product">
            <div className="home-category-page-main-con">
                <div className="row">
                    <div className="col-md-6 order-2 order-md-1">
                        <div className="home-category-page-left-con">
                            <div className="home-category-page-left-main-con">
                                {/* <div className="home-category-page-left-image-con-top">
                                    <div className="home-category-page-left-image-con">
                                        <img
                                            src={productImagePerfume}
                                            alt="Perfume collection preview"
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        />
                                    </div>
                                </div>
                                <h2>Fragrance</h2>
                                <h3>Signature scent, lasting impression.</h3> */}
                                {/* <div className="home-category-page-left-main-bottom-con">
                                    <Link to="/women" className="home-category-page-left-main-bottom-link">
                                        DISCOVER
                                    </Link>
                                </div> */}
                                {/* <h2>THE PHILOSOPHY</h2> */}
                                <h3>1FIVE <span> Fragrance</span></h3>
                                <h4>Fragrance is the final layer of personal style. At 1FIVE, each scent is crafted with precision, blending refined ingredients into compositions that linger with confidence, elegance, and character. Made not just to be noticed, but to be remembered.</h4>
                                <Link to="/fragrance" className="home-category-page-left-main-bottom-link">
                                    DISCOVER MORE
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-1 order-md-2">
                        <div className="home-category-page-right-con">
                            <div className="home-category-page-right-reels-con">
                                <video
                                    ref={videoRef}
                                    src={productreelsPerfume}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    onPlay={() => setIsPlaying(true)}
                                    onPause={() => setIsPlaying(false)}
                                    style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center center" }}
                                />
                                <div className="home-category-page-video-controls">
                                    {isPlaying ? (
                                        <button
                                            type="button"
                                            onClick={handlePause}
                                            className="home-category-page-video-control-btn"
                                            aria-label="Pause video"
                                        >
                                            <IoPause />
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={handlePlay}
                                            className="home-category-page-video-control-btn"
                                            aria-label="Play video"
                                        >
                                            <IoPlay />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomePerfumeProduct;